const appConstants = {
    GOOGLE_RECAPTCHA: "6Lfls3wjAAAAAFAlJOxwliQqlrbYK8PLQUyIIxeB"
}

export { appConstants };